const sponsoring = {
    premium: [
        {
            name: "AOK Rheinland_Hamburg",
            img: "aok.png",
            link: "https://www.aok.de/pk/rh/"
        },
        {
            name: "Henneker Zillinger Ingenieure",
            img: "Henneker-Zillinger-Ingenieure.png",
            link: "https://www.hzi-bonn.de"
        },
        {
            name: "Flughafen Köln/Bonn",
            img: "KoelnBonn-Airport.jpg",
            link: "https://www.koeln-bonn-airport.de"
        },
        {
            name: "Kreissparkasse Köln",
            img: "ksk_koeln.jpg",
            link: "https://www.ksk-koeln.de/de/home.html"
        },
        {
            name: "RHI Magnesita",
            img: "RHI-Magnesita.png",
            link: "https://www.rhimagnesita.com/de/"
        },
        {
            name: "Rheinische Provinzial-, Basalt- und Lavawerke",
            img: "RPBL.png",
            link: "https://www.rpbl.de"
        },
        {
            name: "Saunapark Siebengebirge",
            img: "Saunapark-Siebengebirge.jpg",
            link: "https://www.saunapark-siebengebirge.de"
        },
        {
            name: "Volksbank Köln Bonn",
            img: "Volksbank_KoelnBonn.jpg",
            link: "https://www.volksbank-koeln-bonn.de/startseite.html"
        }
    ],
    normal: [
        // {
        //     name: "Auto Service Peter Schwarz GmbH",
        //     img: "auto_service_perter_schwarz.jpg",
        // },
        {
            name: "Autohaus Thomas",
            img: "autohaus_thomas.jpg",
            link: "https://www.auto-thomas.de/standorte/bonn-koenigswinterer-str-444/?standort=1530&filter=vertrieb&marke=117"
        },
        {
            name: "Basler Versicherungen - Siegbergt Baumert",
            img: "basler_siegbert_baumert.jpg",
        },
        {
            name: "Baustoffe Klein",
            img: "baustoffe_klein.jpg",
            link: "https://baustoffe-klein.de"
        },
        // {
        //     name: "Bloch - Schornsteinfegermeisterei",
        //     img: "bloch_schornsteinfegermeisterei.jpg",
        //     link: "https://www.schornsteinfeger-innung-koeln.de/vis.php?id=1923"
        // },
        // {
        //     name: "Brabender Autoteile",
        //     img: "brabender.jpg"
        // },
        // {
        //     name: "Buchladen Heisterbacherrott",
        //     img: "buchladen_heisterbacherrott.jpg"
        // },
        // {
        //     name: "Brüttgen & Kettler",
        //     img: "buettgen.jpg"
        // },
        // {
        //     name: "Dachdeckermeister Vogt",
        //     img: "dachdeckermeister_vogt.jpg"
        // },
        {
            name: "Frank Personenbeförderung",
            img: "frank_personenbefoerderung.jpg",
            link: "https://frankreisen.de/personenbefoerderung/"
        },
        {
            name: "Gothaer",
            img: "Gothaer_Scherz.jpg",
            link: "https://versicherung.gothaer.de/scherz/"
        },
        // {
        //     name: "Gartenbau Maier",
        //     img: "gartenbau_maier.jpg"
        // },
        // {
        //     name: "Elektrotechnik - Hartung & Casper",
        //     img: "hartung_casper_elektrotechnik.jpg",
        //     link: "https://www.hartung-casper.de"
        // },
        // {
        //     name: "Heizungen & Sanitär - Reiner + Dirk Bellinghausen",
        //     img: "heizungen_sanitaer_reiner_dirk_bellinghausen.jpg"
        // },
        // {
        //     name: "Herrlich Weiblich",
        //     img: "herrlich_weiblich.jpg"
        // },
        {
            name: "HTH Gruppe",
            img: "hth_gruppe.png",
            link: "https://hth-computer.de/hthgruppe/"
        },
        {
            name: "Losem - Garten und Landschaftsbau",
            img: "losem_garten_landschaftsbau.jpg",
            link: "https://www.losem.de"
        },
        // {
        //     name: "MLF - Elektrotechnik",
        //     img: "mlf_elektrotechnik.jpg",
        // },
        {
            name: "Motorgeräte Schwekutsch",
            img: "motorgeraete_schwekutsch.jpg",
            link: "https://schwekutsch.com"
        },
        {
            name: "Obsthof Siegbengebirge",
            img: "obsthof_siebengebirge.jpg",
            link: "https://www.obsthof-siebengebirge.de"
        },
        // {
        //     name: "Physiopractiv Sonja Schwarz",
        //     img: "physiopractiv_sonja_schwarz.jpg",
        // },
        // {
        //     name: "Pylon24",
        //     img: "pylon24.jpg",
        //     link: "https://www.pylon24.de"
        // },
        // {
        //     name: "Quick - Baustoffe",
        //     img: "quick_baustoffe.jpg",
        //     link: "https://www.quick-baustoffe.de"
        // },
        {
            name: "Rewe Fickeis",
            img: "rewe_fickeis.jpeg",
            link: "https://rewe-oberpleis.de"
        },
        {
            name: "Steuerberater Schlöder",
            img: "steuerberater_schloeder.jpg",
            link: "https://www.steuerberater-schloeder.de"
        },
        // {
        //     name: "Studienkreis",
        //     img: "studienkreis.jpg",
        //     link: "https://www.studienkreis.de/"
        // },
        {
            name: "Teamsport Metzler",
            img: "teamsport_metzler.jpg",
            link: "https://www.team-sport-metzler.de"
        },
        // {
        //     name: "Tischlerei Martin Pohl",
        //     img: "tischlerei_martin_pohl.jpg",
        //     link: "https://www.schreiner-tischler.de/koenigswinter/tischlerei-martin-pohl"
        // },
        {
            name: "Werth-Haus-Wohnbau",
            img: "werthhaus_wohnbau.jpg",
            link: "https://www.werth-haus-wohnbau.de"
        },
    ]
}

export default sponsoring;